import React from "react";
import { ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";

export default function KasperskyPartner() {
  return (
    <section className="bg-[#FFFFFF] py-20 border-t">
      <div className="container mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {/* Logo and Header */}
          <div className="flex flex-col items-center justify-center">
            <img
              src="/images/kaspersky-logo.png"
              alt="Kaspersky Official Partner"
              className="w-44 sm:w-52 mb-4"
            />

            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 flex items-center justify-center gap-2">
              <ShieldCheck className="w-8 h-8 text-blue-600" />
              Official Kaspersky Partner
            </h2>

            <p className="mt-4 text-gray-700 max-w-2xl mx-auto text-lg leading-relaxed">
              We are proud to be an <span className="font-semibold text-blue-600">authorized Kaspersky Partner</span>,
              offering genuine Kaspersky products and licenses for individuals, businesses, and enterprises.
              Our partnership ensures access to trusted cybersecurity solutions backed by global expertise.
            </p>

            {/* Product Logos */}
            {/* <div className="mt-8 flex flex-wrap justify-center gap-6">
              <img
                src="/images/kaspersky-total-security.png"
                alt="Kaspersky Total Security"
                className="w-28 sm:w-32 object-contain hover:scale-105 transition-transform"
              />
                <img
                  src="/images/kaspersky-small-office.png"
                  alt="Kaspersky Small Office Security"
                  className="w-28 sm:w-32 object-contain hover:scale-105 transition-transform"
                />
              <img
                src="/images/kaspersky-internet-security.jpeg"
                alt="Kaspersky Internet Security"
                className="w-28 sm:w-32 object-contain hover:scale-105 transition-transform"
              />
            </div> */}

            {/* CTA Button */}
            <motion.a
              href="/contact"
              whileHover={{ scale: 1.05 }}
              className="mt-10 inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-medium shadow-md hover:bg-blue-700 transition-all"
            >
              Get Genuine Kaspersky Licenses
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}